export class Registration {
    name:string;
    email:string;
    password:string="";
    phone_code:string="91";
    mobile:string;
    user_type:string="";
    is_registration:string="1";
    pincode:string="0";
    terms_condition:boolean;
    type:string="Web";
}
